/**
 * OrbDocCoreConceptsPagesSLDocEx1LibraryPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsPagesSLDocEx1LibraryPage
 */

import { useOrbDocCoreConceptsPagesSLDocEx1LibraryPageLogic } from '@/hooks/traits/useOrbDocCoreConceptsPagesSLDocEx1LibraryPageLogic';
import type { OrbDocCoreConceptsPagesSLDocEx1LibraryPageConfig } from '@/hooks/traits/useOrbDocCoreConceptsPagesSLDocEx1LibraryPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsPagesSLLibraryView as OrbDocCoreConceptsPagesSLLibraryViewEntity } from '@app/shared';
import { OrbDocCoreConceptsPagesSLBookFactsView } from '@/components/traits/OrbDocCoreConceptsPagesSLBookFactsView';
import { OrbDocCoreConceptsPagesSLBookShelfView } from '@/components/traits/OrbDocCoreConceptsPagesSLBookShelfView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsPagesSLDocEx1LibraryPageViewProps {
  config?: Partial<OrbDocCoreConceptsPagesSLDocEx1LibraryPageConfig>;
}

export function OrbDocCoreConceptsPagesSLDocEx1LibraryPageView({ config: propsConfig }: OrbDocCoreConceptsPagesSLDocEx1LibraryPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsPagesSLDocEx1LibraryPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsPagesSLLibraryView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsPagesSL" trait="OrbDocCoreConceptsPagesSLDocEx1LibraryPage">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="lg"><OrbDocCoreConceptsPagesSLBookFactsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsPagesSLBookShelfView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsPagesSLDocEx1LibraryPageView;
